// extracted by mini-css-extract-plugin
module.exports = {"root":"Sketch_root__1sk_l","back":"Sketch_back__2S1I6","icon":"Sketch_icon__2Jhzr"};